var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.refreshingApp)?[_vm._v(" Loading new content... ")]:[_vm._v(" New content available. Please "),_c('span',{staticClass:"refresh-btn",on:{"click":function($event){return _vm.$emit('refresh')}}},[_vm._v("REFRESH")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }